import React, { ReactNode } from "react";
import SlButton from "@shoelace-style/shoelace/dist/react/button";
import SlDialog from "@shoelace-style/shoelace/dist/react/dialog";
import "./Modal.css";

interface IModalButton {
  label: string;
  buttonFn: () => void;
}

interface IPropsModal {
  open: boolean;
  onClose: () => void;
  message?: string;
  okButton?: IModalButton;
  closeButton?: IModalButton;
  children?: ReactNode;
  disabled?: boolean;
}

const Modal = ({
  open,
  onClose,
  message,
  okButton,
  closeButton,
  children,
  disabled = false
}: IPropsModal) => {
  return (
    <SlDialog
      open={open}
      onSlAfterHide={onClose}
      className="shoelace-modal"
      noHeader
    >
      <div className="custom-modal">
        {message && <p className="custom-modal-message">{message}</p>}
        {children}
        <div className="custom-modal-actions">
          {okButton && (
            <SlButton
              slot="footer"
              className="custom-modal-actions-button"
              variant="default"
              onClick={okButton.buttonFn}
              disabled={disabled}
            >
              {okButton.label}
            </SlButton>
          )}
          {closeButton && (
            <SlButton
              slot="footer"
              className="custom-modal-actions-button"
              onClick={closeButton.buttonFn}
              disabled={disabled}
            >
              {closeButton.label}
            </SlButton>
          )}
        </div>
      </div>
    </SlDialog>
  );
};

export default Modal;
